export default __webpack_public_path__ + "static/media/brochure-mockup-all.07de6131.png";